import styled from "@emotion/styled";
import { Grid2 } from "@mui/material";

export const GridItem = styled(Grid2)`
  padding: 12px 4px;
`;
